export default __webpack_public_path__ + "static/AIA-CES-Provider-Logo-1057f016e5c18fe1dd36c9d10580daf7.png";